<script>
import {
	pipe,
	map,
	min,
	pickAll,
	merge
} from 'ramda'
import {
	fontSizer,
	scaleStyle,
	$getFontSize
} from '../../theme-helpers'
import tap from 'tap-logger'
import debounce from 'lodash.debounce'
/**
 *
 * Nota: Por cuestiones de eficiencia, la función para hacer resize del texto, corre en single-application y se llama resizeFont
 */

export default {
	props: {
		id: 		  String, // Int
		sticker: 	  Object, // {id, height, start_height, width, start_width, text_color, url}
		stickerText:  Array,  // ['string', 'string']
		stickerText2: Array,
		selectedForm: {
			type:     Object, // {width, height}
			required: true
		},
		font: 		  String, // String
		size: 		  Number,
		min: 		  Number,
		wRef: 		  Number,
	},
	ready() {
		this.line1 = document.getElementById('line1-' + this.id)
		this.line2 = document.getElementById('line2-' + this.id)
		this.setParentStyles()
		$(window).on('resize', this.setParentStyles)
		this.resizeFont()
	},
	data() {
		return {
			parentStyles: {
				height: 0,
				width: 0
			},
			line1: {},
			line2: {},
			font_size: 0
		}
	},

	methods: {
		setParentStyles() {
			// Tamaño de referencia o 100%
			let $container = $(this.$el)

			let width = this.selectedForm.width

			if (this.selectedForm.builder_width) {
				width = this.selectedForm.builder_width
			}

			if (typeof this.wRef === "undefined") {
				this.wRef = width
			}

			// wRef  => $containerWidth
			// width => x

			let containerWidth = $container.width();
			let parentWidth = width * containerWidth / this.wRef
			let aspectRatio = this.selectedForm.height / this.selectedForm.width

			this.parentStyles = {
				height: parentWidth * aspectRatio, // será la altura máxima de cada sticker
				width:  parentWidth,  // será el ancho máximo de cada sticker
			}
		},
		resizeFont() {
			let stampData = pipe(
				pickAll(['height', 'width'])
			)(this.textContainerStyles)

			let ref = $(`#${this.id} .text-container-reference`)
			let line1 = $(`#${this.id} .text-container--line1`)
			let line2 = $(`#${this.id} .text-container--line2`)

			let fz = fontSizer(parseInt(stampData.width, 10), parseInt(stampData.height, 10), ref, line1, line2, this.size, this.min, 'nowhere');

			/*let line1 = $(`#${this.id} .text-container--line1`).css("font-size",this.size);*/
			if (min($getFontSize(line1), $getFontSize(line2)) <= this.size) {
				this.font_size = min($getFontSize(line1), $getFontSize(line2))
			} else {
				this.font_size = this.size;
			}


		}
	},

	computed: {
		fontSizeStyles() {
			return ({
				"font-size": this.size + 'px'
			});
		},
		stickerId() {
			return this.sticker.id
		},
		stickerStyles() {
			return merge({
					height: this.selectedForm.height + 'px',
					width: this.selectedForm.width + 'px',
					backgroundImage: `url(${this.sticker.url})`
				},
				scaleStyle(
					this.parentStyles, {
						height: this.selectedForm.height,
						width: this.selectedForm.width
					}
				)
			)
		},
		textContainerStyles() {

			return merge({
					height: this.sticker.height + 'px',
					width: this.sticker.width + 'px',
					top: this.sticker.start_height + 'px',
					left: this.sticker.start_width + 'px',
					color: this.sticker.text_color
				},
				this.font ? {
					fontFamily: this.font
				} : {}
			)
		}
	},

	events: {
		'resize-font': function() {
			this.resizeFont()
		}
	},

	watch: {
		font_size() {
			this.$dispatch('new-font-size', {
				id: this.sticker.id,
				font_size: this.font_size
			})
		}
	}

}
</script>

<template>
    <div class="sticker-container" :id="id" :style="'height: ' + parentStyles.height + 'px'">
        <div class="sticker" :style="stickerStyles">
            <div class="text-container-main" :style="textContainerStyles">
                <div class="text-container-reference">
                    <p
                        class="text-container text-container--line1"
                        :id="'line'+$index+'-'+id"
                        :style="'font-size: '+size+'px'"
                        v-for="sText in stickerText2"
                        track-by="$index"
                        v-text="sText"
                    ></p>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.sticker {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    &-container {
        position: relative;
        margin-bottom: -20px;
    }
}
.text-container-main {
    // margin-left: 20px;
    position: absolute;
    top: 0;
    background-color: transparent;
}

.text-container-reference {
    position: absolute;
    /*importante para poder resolver el width*/
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin-bottom: 0;
}

p {
    text-align: center;
    margin-top: 0;
    margin-bottom: 5px;

}
</style>



// WEBPACK FOOTER //
// sticker-message-preview.vue?252b4908